export default __webpack_public_path__ + "static/equipment-1M-35b9ab307ac83916ce8a3ec984cf59dc.jpg";